import {
  USER_GET_LIST,
  USER_GET_LIST_SUCCESS,
  USER_GET_LIST_ERROR,
  USER_CREATE,
  USER_CREATE_SUCCESS,
  USER_CREATE_ERROR,
  USER_GET_DETAIL,
  USER_GET_DETAIL_SUCCESS,
  USER_GET_DETAIL_ERROR,
  USER_UPDATE,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_ERROR,
} from '../actions';

const INIT_STATE = {
  loading: false,
  error: '',
  list: [],
  detail: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case USER_GET_LIST:
      return { ...state, loading: true };
    case USER_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: '',
      };
    case USER_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case USER_CREATE:
      return { ...state, loading: true };
    case USER_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case USER_CREATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case USER_UPDATE:
      return { ...state, loading: true };
    case USER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case USER_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return { ...state };
  }
};
